// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__ol6Fc","question":"Question_question__1AVL1","description":"Question_description__1St7H"};